var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col full-height",class:{ 'bg-white': !_vm.isAuthenticated || _vm.hideSideBar }},[(_vm.isAuthenticated && !_vm.hideSideBar)?_c('sidebar',{model:{value:(_vm.sidebarCollapsed),callback:function ($$v) {_vm.sidebarCollapsed=$$v},expression:"sidebarCollapsed"}}):_vm._e(),_c('div',{staticClass:"full-height main-content",class:{
      'offset': !_vm.sidebarCollapsed && _vm.isAuthenticated && !_vm.hideSideBar,
      'sidebar-width': _vm.sidebarCollapsed && _vm.isAuthenticated && !_vm.hideSideBar,
    }},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }